import {defineField, defineType} from 'sanity'
import {VscLink} from 'react-icons/vsc'
import resolveSlug from '@/lib/resolveSlug'
import dotcomPage from '../fragments/dotcom.page'

export default defineType({
  name: 'link',
  title: 'Link',
  icon: VscLink,
  type: 'object',

  fields: [
    defineField({
      name: 'label',
      type: 'string',
    }),
    defineField({
      name: 'type',
      type: 'string',
      options: {
        layout: 'radio',
        list: [
          {title: 'internal', value: 'internal'},
          {title: 'dotcom', value: 'dotcom'},
          {title: 'external', value: 'external'},
        ],
      },
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'internal',
      type: 'reference',
      to: [
        {type: 'page'},
        {type: 'blog.category'},
        {type: 'blog.tag'},
        {type: 'blog.category-cluster'},
      ],
      hidden: ({parent}) => parent?.type !== 'internal',
    }),
    {...dotcomPage, hidden: ({parent}) => parent?.type !== 'dotcom'},
    defineField({
      name: 'external',
      placeholder: 'https://example.com',
      type: 'url',
      validation: (Rule) =>
        Rule.uri({
          scheme: ['http', 'https', 'mailto', 'tel'],
          allowRelative: true,
        }),
      hidden: ({parent}) => parent?.type !== 'external',
    }),
    defineField({
      name: 'params',
      title: 'URL parameters',
      placeholder: 'e.g. #jump-link or ?foo=bar',
      type: 'string',
      hidden: ({parent}) => parent?.type !== 'internal',
    }),
  ],
  preview: {
    select: {
      label: 'label',
      _type: 'internal._type',
      title: 'internal.title',
      internal: 'internal.metadata.slug.current',
      params: 'params',
      external: 'external',
    },
    prepare: ({label, title, _type, internal, params, external}) => ({
      title: label || title,
      subtitle: resolveSlug({_type, internal, params, external}),
    }),
  },
})
